import React from 'react';
import { Step } from 'react-joyride';
import BaseTour from './BaseTour';
import { useTranslation } from 'react-i18next';

interface TelegramSetupTourProps {
    isRunning: boolean;
    onComplete: () => void;
}

const TelegramSetupTour: React.FC<TelegramSetupTourProps> = ({ isRunning, onComplete }) => {
    const { t } = useTranslation();

    const steps: Step[] = [
        {
            target: 'body',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.telegram_notifications.welcome.title')}
                    </h3>
                    <p>{t('app_tour.telegram_notifications.welcome.description')}</p>
                </div>
            ),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: 'a[href="https://t.me/SentolaBot"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.telegram_notifications.step1.title')}
                    </h3>
                    <p>{t('app_tour.telegram_notifications.step1.description')}</p>
                </div>
            ),
            placement: 'bottom',
        },
        {
            target: 'body',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.telegram_notifications.step2.title')}
                    </h3>
                    <p style={{ marginBottom: '16px' }}>
                        {t('app_tour.telegram_notifications.step2.description')}
                    </p>
                    <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'center' }}>
                        <img
                            src="/assets/images/sentola-tg-bot-start.png"
                            alt="Telegram bot start"
                            style={{
                                width: '250px',
                                objectFit: 'contain',
                                borderRadius: '8px',
                                border: '1px solid #e5e7eb',
                                backgroundColor: '#f9fafb',
                            }}
                        />
                    </div>
                    <div style={{ marginBottom: '16px' }}>
                        <p style={{ marginBottom: '8px' }}>
                            {t('app_tour.telegram_notifications.step2.chatid_preview')}
                        </p>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <img
                                src="/assets/images/sentola-tg-bot-chatid.png"
                                alt="Telegram bot chat ID"
                                style={{
                                    width: '250px',
                                    objectFit: 'contain',
                                    borderRadius: '8px',
                                    border: '1px solid #e5e7eb',
                                    backgroundColor: '#f9fafb',
                                }}
                            />
                        </div>
                    </div>
                    <p>
                        <strong>{t('app_tour.telegram_notifications.step2.important')}</strong>
                    </p>
                </div>
            ),
            placement: 'center',
            disableBeacon: true,
            hideCloseButton: false,
        },
        {
            target: 'input[placeholder="Paste chat ID here"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.telegram_notifications.step3.title')}
                    </h3>
                    <p>{t('app_tour.telegram_notifications.step3.description')}</p>
                </div>
            ),
            placement: 'top',
        },
        {
            target: '#updateTgChatIdButton',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.telegram_notifications.step4.title')}
                    </h3>
                    <p>{t('app_tour.telegram_notifications.step4.description')}</p>
                </div>
            ),
            placement: 'right',
            spotlightPadding: 20,
        },
    ];


    return <BaseTour isRunning={isRunning} onComplete={onComplete} tourId="telegram-notifications" steps={steps} />;
};

export default TelegramSetupTour;
